import $ from 'jquery'
import {state} from './State'
import {
    updateButtonState, saveToCoockie, getCookie, deleteCookie, isEmpty, updateState, foreachCb, hasParentId,
    ensureAttribute, fromAttribute, root, get_first_tabindex, locale,get_last_tabindex
} from './Helpers'
import {ACC_COOCKIE,ACTIVE_ACC_CLASS, EVENT_TOGGLE_TOOLBAR, EVENT_KEYBOARD_NAV_OPENED,} from './Params'

export default class Actions {

    //fonts
    increaseFontSize() {

        foreachCb(state.fontTypes, (k, v) => {
            const elements = document.getElementsByTagName(v)
            foreachCb(elements, (j, element) => {
                if(hasParentId(element, 'acc-toolbar-wrap')) {
                    return
                }

                let origFz = getComputedStyle(element).fontSize
                let origLh = getComputedStyle(element).lineHeight
                let origFzFloat = parseFloat(origFz)
                let origLhFloat = parseFloat(origLh)
                if(isEmpty(origFz) || isNaN(origFzFloat)) {
                    origFzFloat = state.minFontSize
                }
                if(origFzFloat >= state.maxFontSize) {
                    return
                }
                ensureAttribute('fontSize', element)
                element.style.fontSize = ""
                element.style.lineHeight = ""
                element.style.cssText += `;font-size:${(origFzFloat + 1)}px !important;line-height:${(origLhFloat + 1)}px !important`
            })
        })
    };

    decreaseFontSize(el) {

        foreachCb(state.fontTypes, (k, v) => {
            const elements = document.getElementsByTagName(v)
            foreachCb(elements, (j, element) => {
                if(hasParentId(element, 'acc-toolbar-wrap')) {
                    return
                }

                let origFz = getComputedStyle(element).fontSize
                let origLh = getComputedStyle(element).lineHeight
                let origFzFloat = parseFloat(origFz)
                let origLhFloat = parseFloat(origLh)

                if(isEmpty(origFz) || isNaN(origFzFloat)) {
                    origFzFloat = state.minFontSize
                }
                if(origFzFloat <= state.minFontSize) {
                    return
                }
                ensureAttribute('fontSize', element)
                element.style.fontSize = ""
                element.style.cssText += `;font-size:${(origFzFloat - 1)}px !important;line-height:${(origLhFloat - 1)}px !important`
            })
        })
    };

    resetFontSize(el) {
        $(el).removeClass('active')

        foreachCb(state.fontTypes, function(k, v) {
            var elements = document.getElementsByTagName(v)
            foreachCb(elements, (j, element) => {
                fromAttribute('fontSize', element)
            })
        })
    };

    fixFonts() {
        const button = $('#acc-font-readable')
        const active = button.hasClass('active')
        updateButtonState(button, !active)
        $('body').toggleClass('acc-fixFonts', !active)
        updateState('fixFonts', true, !active)
        saveToCoockie()
    };

    //alts
    ImagesAlt() {
        const button = $('#acc-imgalt')
        const active = button.hasClass('active')
        updateButtonState(button, !active)
        $('body').toggleClass('acc-ImagesAlt', !active)
        updateState('ImagesAlt', true, !active)
        saveToCoockie()

        if(!active) {
            $('img').hover((e) => {
                let text = $(e.target).attr('alt')
                let po = [e.clientX, e.clientY]
                let altpop = $('<span id="popalt" class="altpop">').text(text)
                altpop.css({'top': po[1], 'left': po[0]})
                $('body').append(altpop)
            }, () => {
                $('#popalt').remove()
            })
        }
    };

    //titles
    highlightTitles() {
        const button = $('#acc-titles')
        const active = button.hasClass('active')
        updateButtonState(button, !active)
        $('body').toggleClass('acc-highlightTitles', !active)
        updateState('highlightTitles', true, !active)
        saveToCoockie()
    };

    //links
    highlightLinks() {
        const button = $('#acc-links')
        const active = button.hasClass('active')
        updateButtonState(button, !active)
        $('body').toggleClass('acc-highlightLinks', !active)
        updateState('highlightLinks', true, !active)
        saveToCoockie()
    };

    //animations
    disableAnimation(e) {
        const button = $('#acc-animation')
        const active = button.hasClass('active')
        updateButtonState(button, !active)
        $('body').toggleClass('acc-animation', !active)
        updateState('disableAnimation', true, !active)
        saveToCoockie()
        if(typeof window.disableAnimation === 'function'){
            window.disableAnimation(state.disableAnimation)
        }
    };


    //zoom
    setZoom(e) {
        const button = $('#acc-zoom')
        const active = button.hasClass('active')
        updateButtonState(button, !active)
        $('body').toggleClass('acc-zoom', !active)
        updateState('setZoom', true, !active)
        saveToCoockie()
    };

    //cursor
    setCursor(type) {
        const button = $('#acc-toolbar-ui > button[data-type=' + type + ']')
        const bodyClass = 'acc-cursor-' + type
        const active = button.hasClass('active')

        if(!type || active) {
            this.resetCursor()
            return
        }

        if(!active) {
            this.resetCursor()
            updateButtonState(button, true)
            $('body').addClass(bodyClass)
            updateState('setCursor', type, true)
            saveToCoockie()
        }
    };

    resetCursor() {
        $('#acc-cursor-b,#acc-cursor-w').each((i, e) => {
            updateButtonState($(e), false)
        })
        updateState('setCursor', false, false)
        document.body.classList.remove('acc-cursor-b', 'acc-cursor-w')
        saveToCoockie()
    };

    //contrast
    setContrast(type) {
        const button = $('#acc-toolbar-contrast > button[data-type=' + type + ']')
        const bodyClass = 'acc-' + type
        const active = button.hasClass('active')

        if(active) {
            this.resetContrast()
            return
        }
        if(!active) {
            this.resetContrast()
            updateButtonState(button, true)
            updateState('setContrast', type, true)
            document.body.classList.add(bodyClass)
            saveToCoockie()

            //ACTIVE_ACC_CLASS
        }
    };

    resetContrast() {
        $('#acc-toolbar-contrast > button').each((i, e) => {
            updateButtonState($(e), false)
        })

        updateState('setContrast', false, false)
        document.body.classList.remove('acc-dark', 'acc-bright', 'acc-mono')
        saveToCoockie()
    };

    darkContrast(toggle, type) {
        var elCss = ""
        if(type == 'dark') {
            access.darkContrastState = !!toggle
            elCss = "color: white !important;background:black !important;"
        }
        if(type == 'bright') {
            access.brightContrastState = !!toggle
            elCss = "color: black !important;background:white !important;"
        }
        var types = ['p', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'section', 'article', 'span', 'div', 'body', 'table', 'td', 'th', 'input', 'select', 'button']
        foreachCb(types, function(k, v) {
            var elements = document.getElementsByTagName(v)
            foreachCb(elements, function(j, element) {
                if(hasParentId(element, 'acc-toolbar-wrap')) {
                    return
                }
                ensureAttribute('color', element, 0)
                ensureAttribute('background', element, 1)
                ensureAttribute('backgroundColor', element, 1)
                ensureAttribute('outline', element, 1)

                if(access.darkContrastState) {
                    element.style.background = ""
                    element.style.color = ""
                    element.style.backgroundColor = ""
                    element.style.outline = ""
                    element.style.filter = ""
                    element.style.cssText += elCss
                    if(v == 'a') {
                        element.style.cssText += 'outline: 1px dashed yellow !important'
                    }
                }
                else {
                    fromAttribute('color', element)
                    fromAttribute('background', element)
                    fromAttribute('backgroundColor', element)
                    fromAttribute('outline', element)
                }
            })
        })
    };


    //keyboard nav
    keyboardNav(e) {
        const button = $('#acc-keyboard')
        const active = state.keyboardNav
        updateButtonState(button, !active)
        $('body').toggleClass('acc-keyboard', !active);
        $('body').toggleClass('using-mouse', active);
        updateState('keyboardNav', true, !active)
        saveToCoockie()
        this.toggleKeybordNav(!active)

    };

    toggleKeybordNav(active) {
        if(!active) {
            root().keybord_nav.destroy()
            return
        }
        if(root().isOpen) {
            $(document).trigger(EVENT_TOGGLE_TOOLBAR)
        }
        root().keybord_nav.open()
    };

    focusOnProducts() {
        var hasPop = $('.ama-popup:visible').length
        if(hasPop) {
            setTimeout(function() {
                $('.ama-popup').find('*[tabindex]').first().focus()
            }, 200)
        }
    };


    //load coockies
    loadCookieInfo() {
        const info = getCookie(ACC_COOCKIE);
        if(info) {
            Object.keys(info).map((key) => {
                this[key](info[key])
            })
        }

    };

    clearAll() {
        deleteCookie(ACC_COOCKIE)
        window.location.reload()
    };

    onPageLoad() {
        this.loadCookieInfo()
    }

    onTogglePanel(x) {
        root().isOpen = x !== undefined ? x.isOpen : !root().isOpen
        let flag = root().isOpen
        root().toolbar.visible = flag
        root().mainbtn.visible = !flag
        if(state.keyboardNav) {
            //  root().keybord_nav.visible = !flag
        }
        if(flag) {
            root().toolbar.focus()
            return
        }
        else {
            get_first_tabindex($('body')).focus()
        }
    };


    onPressEnter(elem,cb) {
        elem.keyup(function(e){
            if(typeof cb === 'function'){cb()}
            else{
                elem.click()
            }
        });
    }

    onHideAcc(){
        $('body').removeClass('hasNav')
        root().toolbar.visible = false
        root().mainbtn.visible = false
        root().keybord_nav.visible = false
    }
}


export const actions = new Actions()
